import {
  GET_ACCOUNT_STATUS_V2,
  GET_ACCOUNT_STATUS_V2_SUCCESS,
  GET_ACCOUNT_STATUS_V2_FAILED,
  GET_ACC_STS_SUCCESS,
  GET_ACC_STS_FAILED,
  GET_CUSTOMER_PORTFOLIO,
  GET_CUSTOMER_PORTFOLIO_SUCCESS,
  GET_CUSTOMER_PORTFOLIO_FAILED,
  GET_SUBACCOUNT_INVEST,
  GET_SUBACCOUNT_INVEST_SUCCESS,
  GET_SUBACCOUNT_INVEST_FAILED,
  RESET_INVEST_SUBACCOUNT,
  GET_INVEST_ANNOUNCEMENT,
  GET_INVEST_ANNOUNCEMENT_SUCCESS,
  GET_INVEST_ANNOUNCEMENT_FAILED,
  GET_RETIRE_ANNOUNCEMENT,
  GET_RETIRE_ANNOUNCEMENT_SUCCESS,
  GET_RETIRE_ANNOUNCEMENT_FAILED,
  GET_SAVE_ANNOUNCEMENT,
  GET_SAVE_ANNOUNCEMENT_SUCCESS,
  GET_SAVE_ANNOUNCEMENT_FAILED
} from "./constant";

export const resetInvestSubAccount = () => {
  return {
    type: RESET_INVEST_SUBACCOUNT
  };
};

export function getSubAccountInvest(data, callback) {
  return {
    type: GET_SUBACCOUNT_INVEST,
    payload: data,
    callback
  };
}

export function getSubAccountInvestSuccess(data) {
  return {
    type: GET_SUBACCOUNT_INVEST_SUCCESS,
    payload: data
  };
}

export function getSubAccountInvestFailed(data) {
  return {
    type: GET_SUBACCOUNT_INVEST_FAILED,
    payload: data
  };
}

export function getCustomerPortfolio(callback) {
  return {
    type: GET_CUSTOMER_PORTFOLIO,
    callback
  };
}

export function getCustomerPortfolioSuccess(data) {
  return {
    type: GET_CUSTOMER_PORTFOLIO_SUCCESS,
    payload: data
  };
}

export function getCustomerPortfolioFailed() {
  return {
    type: GET_CUSTOMER_PORTFOLIO_FAILED
  };
}

export function getAccountStatusV2(data, callback) {
  return {
    type: GET_ACCOUNT_STATUS_V2,
    payload: data,
    callback
  };
}

export function getAccountStatusV2Success(data) {
  return {
    type: GET_ACCOUNT_STATUS_V2_SUCCESS,
    payload: data
  };
}

export function getAccountStatusV2Failed(data) {
  return {
    type: GET_ACCOUNT_STATUS_V2_FAILED,
    payload: data
  };
}

export function getAccStsSuccess(data) {
  return {
    type: GET_ACC_STS_SUCCESS,
    payload: data
  };
}

export function getAccStsFailed(data) {
  return {
    type: GET_ACC_STS_FAILED,
    payload: data
  };
}

export function getInvestAnnouncement(data, callback) {
  return {
    type: GET_INVEST_ANNOUNCEMENT,
    payload: data,
    callback
  }
}

export function getInvestAnnouncementSuccess(data) {
  return {
    type: GET_INVEST_ANNOUNCEMENT_SUCCESS,
    payload: data,
  }
}

export function getInvestAnnouncementFailed() {
  return {
    type: GET_INVEST_ANNOUNCEMENT_FAILED,
  }
}

export function getRetireAnnouncement(data, callback) {
  return {
    type: GET_RETIRE_ANNOUNCEMENT,
    payload: data,
    callback
  }
}

export function getRetireAnnouncementSuccess(data) {
  return {
    type: GET_RETIRE_ANNOUNCEMENT_SUCCESS,
    payload: data,
  }
}

export function getRetireAnnouncementFailed() {
  return {
    type: GET_RETIRE_ANNOUNCEMENT_FAILED,
  }
}

export function getSaveAnnouncement(data, callback) {
  return {
    type: GET_SAVE_ANNOUNCEMENT,
    payload: data,
    callback
  }
}

export function getSaveAnnouncementSuccess(data) {
  return {
    type: GET_SAVE_ANNOUNCEMENT_SUCCESS,
    payload: data,
  }
}

export function getSaveAnnouncementFailed() {
  return {
    type: GET_SAVE_ANNOUNCEMENT_FAILED,
  }
}